import { SELECTED_PERIOD_ID } from './constants/localStorage';

export const getSelectedPeriodIdFromLocalStorage = () =>
  localStorage.getItem(SELECTED_PERIOD_ID);
